import React from "react";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Text, Heading, Badge, Button, Flex } from "@chakra-ui/react";
import { TConfirmation } from "../types";
import { getFeatureFlagStatus } from "../../../../featureFlags";

const nftBridgeEnabled = getFeatureFlagStatus("nftBridgeEnabled");

const SuccessStep = (_props: TConfirmation) => (
  <Box p="16px">
    <CTASection
      title="Get assets on Palm"
      desc="DAI is a cryptocurrency pegged to the US Dollar, and is the most common token used to pay
      for NFTs and services on Palm. You can bring your existing DAI tokens from the Ethereum network to Palm using
      the token bridge. The bridge lets you bring other ERC-20 tokens to Palm, including Wrapped ETH (WETH)
      and Portion (PRT). When using the bridge, you will receive PALM tokens which are used to pay
      for gas on Palm network."
    >
      <CTACard
        title="Token Bridge"
        desc="Bridge DAI between Ethereum and Palm."
        badge={false}
        badgeCopy="PALM provided"
        buttonCopy="Get Started"
        buttonLink="bridge"
      />
      {nftBridgeEnabled && (
        <CTACard
          title="NFT Bridge"
          desc="Transfer NFTs between Ethereum and Palm."
          badge={false}
          badgeCopy="PALM provided"
          buttonCopy="Get Started"
          buttonLink="nftbridge"
        />
      )}
    </CTASection>
  </Box>
);

export default SuccessStep;

interface ICTACard {
  title?: any;
  desc?: any;
  badge?: boolean;
  badgeCopy?: any;
  buttonCopy?: any;
  buttonLink?: any;
}

const CTACard: React.FC<ICTACard> = ({
  title,
  desc,
  badge,
  badgeCopy,
  buttonCopy,
  buttonLink,
}: ICTACard) => {
  const navigate = useNavigate();
  return (
    <Box
      w="200px"
      bg="palmNetwork.200"
      border="1px solid"
      borderColor="palmNetwork.100"
      color="palmNetwork.100"
      p="8"
      mr="24px"
      display="flex"
      flexWrap="wrap"
      justifyContent="center"
    >
      <Box mb="24px">
        <Heading as="h3" fontSize="24px" mr="16px" mb="24px">
          {title}
        </Heading>
        {badge && (
          <Badge
            borderRadius="0px"
            bg="#8142D5"
            color="white"
            textTransform="none"
          >
            {badgeCopy}
          </Badge>
        )}
        <Text fontSize="16px" mb="32px">
          {desc}
        </Text>
      </Box>
      <Box alignSelf="flex-end">
        <Button onClick={() => navigate(`/${buttonLink}`)}>{buttonCopy}</Button>
      </Box>
    </Box>
  );
};

interface ICTASection {
  title?: any;
  desc?: any;
  children: ReactNode | ReactNode[];
}

const CTASection: React.FC<ICTASection> = ({
  title,
  desc,
  children,
}: ICTASection) => {
  return (
    <Box pb="48px">
      <Heading fontSize="24px" mb="16px">
        {title}
      </Heading>
      <Text mb="32px">{desc}</Text>
      <Flex flexWrap="wrap" justifyContent="center" margin="auto">
        {children}
      </Flex>
    </Box>
  );
};
